export class ApiError extends Error {
  constructor(
    message: string,
    public status?: number,
    public code?: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export class UnauthorizedError extends ApiError {
  constructor(
    message: string = 'You are not authorized to perform this action.',
  ) {
    super(message);
    this.name = 'UnauthorizedError';
    this.code = 'UNAUTHORIZED';
    this.status = 401;
  }
}

export class ForbiddenError extends ApiError {
  constructor(message: string = 'You do not have permission for this action.') {
    super(message);
    this.name = 'ForbiddenError';
    this.code = 'FORBIDDEN';
    this.status = 403;
  }
}

export class TooManyRequestsError extends ApiError {
  constructor(message: string = 'Too many requests. Please slow down.') {
    super(message);
    this.name = 'TooManyRequestsError';
    this.code = 'TOO_MANY_REQUESTS';
    this.status = 429;
  }
}

export class ServerError extends ApiError {
  constructor(status: number, message: string) {
    super(message);
    this.name = 'ServerError';
    this.code = 'SERVER_ERROR';
    this.status = status;
  }
}

export function isForbiddenError(error: unknown): error is ForbiddenError {
  if (error instanceof ForbiddenError) return true;
  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    (error as {status: unknown}).status === 403
  )
    return true;
  return false;
}

export function isTooManyRequestsError(
  error: unknown,
): error is TooManyRequestsError {
  if (error instanceof TooManyRequestsError) return true;
  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    (error as {status: unknown}).status === 429
  )
    return true;
  return false;
}
